import { client } from 'client/request';
import { ADMIN_NEWS, NEWS_CATEGORY, LIST_NEWS, NEWS_MULTI_CATEGORIES } from 'client/api';

import { combineUrlParams } from 'utils';
import { IParams, some } from 'types';

const post = (body) => {
  return new Promise((resolve, reject) => {
    client
      .post(ADMIN_NEWS, body)
      .then((res) => {
        const { data } = res;

        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getCategories = (params, signal?: AbortSignal) => {
  const url = combineUrlParams(NEWS_CATEGORY, params);

  return new Promise((resolve, reject) => {
    client
      .get(url, { signal })
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const postCategory = (body, params?: some) => {
  const url = combineUrlParams(NEWS_CATEGORY, params);
  return new Promise((resolve, reject) => {
    client
      .post(url, body)
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const deleteCategory = (id) => {
  return new Promise((resolve, reject) => {
    client
      .delete(NEWS_CATEGORY, { data: { id } })
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getListNews = (params) => {
  const url = combineUrlParams(LIST_NEWS, params);

  return new Promise((resolve, reject) => {
    client
      .get(url, {})
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getNewsById = (id) => {
  return new Promise((resolve, reject) => {
    const url = ADMIN_NEWS + `/${id}`;
    client
      .get(url, {})
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const deleteNews = (id) => {
  return new Promise((resolve, reject) => {
    const url = ADMIN_NEWS;

    client
      .delete(url, { data: { id } })
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const upsertMultiCategories = async ({ params, signal }: IParams) => {
  const url = NEWS_MULTI_CATEGORIES;
  const res: some = await client.post(url, params, { signal });
  return res;
};

export default {
  post,
  getCategories,
  getListNews,
  getNewsById,
  deleteNews,
  postCategory,
  deleteCategory,
  upsertMultiCategories
};
